/************
 * Model Class
 * File Name ...: messages-sent.components.ts
 * Generated By : ianday on 1/9/24
 * Date ........: 1/9/24
 /************/
import {ValidationResult} from './validation-result';

export interface MessagesSent {
    id: number;
    mailDefinitionId: number;
    foreignKeyTable: string;
    foreignKeyId: number;
    agencyId: number;
    agencyName: string;
    dateSent: Date | null;
    sentBy: string | null;
    sentTo: string | null;
    sentCc: string | null;
    subject: string | null;
    messageBody: string | null;
    status: string | null;
}

export class MessagesSent {
    constructor() {
        this.id = 0;
        this.mailDefinitionId = 0;
        this.foreignKeyTable = '';
        this.foreignKeyId = 0;
        this.agencyId = 0;
        this.agencyName ='';
        this.dateSent = null;
        this.sentBy = '';
        this.sentTo = '';
        this.sentCc = '';
        this.subject = '';
        this.messageBody = '';
    }
    public setMessageSent(id:number, mailDefinitionId:number, agencyId:number, agencyName:string, foreignKeyTable: string = 'Cases' ): void {
        this.id = 0;
        this.mailDefinitionId = mailDefinitionId;
        this.foreignKeyTable = foreignKeyTable;
        this.foreignKeyId = id;
        this.agencyId = agencyId;
        this.agencyName = agencyName;
        this.dateSent = new Date();
        this.sentBy = '';
        this.sentTo = '';
        this.sentCc = '';
        this.subject = '';
        this.messageBody = '';
        this.status = 'Sent';
     }
    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();
        return vr;
    }
}
